import styled from 'styled-components';
import { mq, getFixedSpace } from '../../../../stylesheets/tools';

const StyledEducationTabletHeader = styled.section`
  .header__wrapper {
    padding: ${getFixedSpace('xs')};
    display: flex;
    justify-content: space-between;

    .header__wrapper-logo {
      display: none;

      ${mq('m')} {
        display: block;
      }
    }
    ${mq('xl')} {
      flex-wrap: nowrap;
      padding: ${getFixedSpace('xs')} ${getFixedSpace('m')};
    }
  }
`;

export default StyledEducationTabletHeader;
